import { useCallback, useState } from "react";

interface Announcement {
  text: string;
  id: number;
}

export function useAnnouncer() {
  const [announcement, setAnnouncement] = useState<Announcement>({
    text: "",
    id: 0,
  });

  const announce = useCallback((text: string) => {
    setAnnouncement((previous) =>
      previous.text === "" && text === ""
        ? previous
        : { text, id: previous.id + 1 },
    );
  }, []);

  const retract = useCallback((text: string) => {
    setAnnouncement((previous) =>
      previous.text === text ? { text: "", id: previous.id + 1 } : previous,
    );
  }, []);

  return { announcement, announce, retract };
}
